import CompareVehicleInfo from '@v4/compare/components/molecules/CompareVehicleInfo/CompareVehicleInfo';

export default CompareVehicleInfo;
